(function (window) {
  'use strict';

  const footer = document.querySelector('.footer');
  const navigationMenus = document.querySelectorAll('.js-footer-nav-menu');
  const activeMenuClass = 'js-footer-nav-menu--active';
  const buttons = [];

  let setToSmall;

  function activateLinks(listAnchors) {
    for (let i = 0; i < listAnchors.length; i++) {
      listAnchors[i].removeAttribute('tabindex');
    }
  }

  function deactivateLinks(listAnchors) {
    for (let i = 0; i < listAnchors.length; i++) {
      listAnchors[i].setAttribute('tabindex', -1);
    }
  }

  function toggleMenu(e) {
    const menu = e.target.parentNode;
    const submenu = menu.querySelector('.footer-nav__menu-items');
    const listLinks = submenu.querySelectorAll('a');

    menu.classList.toggle(activeMenuClass);
    submenu.style.height = menu.classList.contains(activeMenuClass) ? `${submenu.scrollHeight}px` : 0;

    if (menu.classList.contains(activeMenuClass)) {
      e.target.setAttribute('aria-expanded', true);
      submenu.setAttribute('aria-hidden', false);
      activateLinks(listLinks);
    } else {
      e.target.setAttribute('aria-expanded', false);
      submenu.setAttribute('aria-hidden', true);
      deactivateLinks(listLinks);
    }
  }

  function widthChange(mq) {
    const footerNavMenuItemsAnchors = document.querySelectorAll('.footer-nav__menu-item a');

    if (mq.matches === true && setToSmall !== false) {
      activateLinks(footerNavMenuItemsAnchors);
      const elements = document.querySelectorAll('.footer-nav__menu-items');
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.height = 'auto';
      }
      setToSmall = false;
    } else if (setToSmall !== true) {
      deactivateLinks(footerNavMenuItemsAnchors);
      const elements = document.querySelectorAll('.footer-nav__menu');
      for (let i = 0; i < elements.length; i++) {
        const submenu = elements[i].querySelector('.footer-nav__menu-items');
        submenu.style.height = elements[i].classList.contains(activeMenuClass) ? `${submenu.scrollHeight}px` : 0;
      }
      setToSmall = true;
    }
    setAria();
  }

  function setAria() {
    const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    const mobile = width < 680;
    buttons.map(button => button.setAttribute('aria-disabled', !mobile));
  }

  if (footer) {
    for (let i = 0; i < navigationMenus.length; i++) {
      const menu = navigationMenus[i];
      const button = menu.querySelector('.js-footer-nav-button');

      if (button) {
        button.addEventListener('click', toggleMenu);
        buttons.push(button);
      }
    }

    // media query event handler
    if (matchMedia) {
      const mq = window.matchMedia('(min-width: 680px)');
      mq.addListener(widthChange);
    }

    const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    if (width < 680) {
      // Set tabindex="-1" on all footer nav menu item links.
      const footerNavMenuItemsAnchors = document.querySelectorAll('.footer-nav__menu-item a');
      deactivateLinks(footerNavMenuItemsAnchors);

      const footerNavMenuItems = document.querySelectorAll('.footer-nav__menu-items');
      for(let i = 0; i < footerNavMenuItems.length; i++) {
        footerNavMenuItems[i].setAttribute('aria-hidden', true);
      }
    }

    setAria();
  }

})(this);
